export const StudentConstModules: { [key: string]: string } = {
  "information": "student/information",
  "assessments": "student/student.assessments",
  "attendance": "student/student.attendance",
  "attendance-by-period": "student/student.attendance-by-period",
  "historical-behaviors": "student/student.historical-behaviors",
  "achievements": "student/staff.achievements",
  "parent-notification": "student/staff.parent-notification",
  "initialcontact": "student/staff.parent-notification",
  "communication": "student/staff.communication",
  "running-record": "student/staff.running-record",
  "behavior-intervention": "student/staff.behavior-intervention",
  "intervention-logs": "student/staff.intervention-logs",
  "irip": "student/staff.irip",
  "observational-data": "student/staff.observational-data",
  "other-factors": "student/staff.other-factors",
  "meetings": "student/meetings",
};

export class StudentBlock {
  path: string;
  name: string;
  constructor(path: string, name: string) {
    this.path = path;
    this.name = name;
  }
}

export const StudentConstObject: { [key: string] : StudentBlock} = {
  "information": new StudentBlock("student/information", "Information"),
  "assessments": new StudentBlock("student/student.assessments", "Assessments"),
  "attendance": new StudentBlock("student/student.attendance", "Attendance"),
  "attendance-by-period": new StudentBlock("student/student.attendance-by-period", "Attendance by Period"),
  "historical-behaviors": new StudentBlock("student/student.historical-behaviors", "Historical Behaviors"),
  "achievements": new StudentBlock("student/staff.achievements", "Achievements"),
  "parent-notification": new StudentBlock("student/staff.parent-notification", "Parent Notification"),
  "communication": new StudentBlock("student/staff.communication", "Communication"),
  "running-record": new StudentBlock("student/staff.running-record", "Running Record"),
  "behavior-intervention": new StudentBlock("student/staff.behavior-intervention", "Behavior Intervention"),
  "intervention-logs": new StudentBlock("student/staff.intervention-logs", "Intervention Logs"),
  "irip": new StudentBlock("student/staff.irip", "IRIP"),
  "observational-data": new StudentBlock("student/staff.observational-data", "Observational Data"),
  "other-factors": new StudentBlock("student/staff.other-factors", "Other Factors"),
  "meetings": new StudentBlock("student/meetings", "Meetings"),
}

export const StudentsModuleStudentTabConst: { [key: string]: StudentBlock } =
  Object.fromEntries(
    Object.entries(StudentConstObject).filter(([_, value]) =>
      value.path.indexOf("student/student") !== -1
    )
  ) as { [key: string]: StudentBlock };

export const StudentsModuleStaffTabConst: { [key: string]: StudentBlock } =
  Object.fromEntries(
    Object.entries(StudentConstObject).filter(([_, value]) =>
      value.path.indexOf("student/staff") !== -1
    )
  ) as { [key: string]: StudentBlock };
